import React from 'react';

/**
 * ModalTabSelector — the ONE segmented tab control used inside modals
 * (Edit Role: Role/Permissions · Edit Team Member: Basic/Role · …).
 * Keeps every in-modal tab switcher visually identical across the app.
 *
 * @param {Array<{ value: string, label: string, icon?: React.ComponentType }>} tabs
 * @param {string} value           currently active tab value
 * @param {(value: string) => void} onChange
 */
const ModalTabSelector = ({ tabs = [], value, onChange, className = '' }) => (
  <div
    role="tablist"
    className={`inline-flex w-full items-center gap-1 rounded-xl bg-gray-100 p-1 ${className}`}
  >
    {tabs.map((tab) => {
      const Icon = tab.icon;
      const active = value === tab.value;
      return (
        <button
          key={tab.value}
          type="button"
          role="tab"
          aria-selected={active}
          onClick={() => onChange(tab.value)}
          data-testid={`modal-tab-${tab.value}`}
          className={`flex-1 flex items-center justify-center gap-1.5 rounded-lg px-3 py-2 text-sm font-medium transition-all duration-150 ${
            active
              ? 'bg-white text-gray-900 shadow-[0_2px_8px_rgba(0,0,0,0.06)]'
              : 'text-gray-500 hover:text-gray-800'
          }`}
        >
          {Icon && <Icon className="w-4 h-4" />}
          {tab.label}
        </button>
      );
    })}
  </div>
);

export default ModalTabSelector;
